export const BUSINESS_PROFILE_REDUCER = 'businessProfile'
export const CREATE_PROFILE_REDUCER = 'createProfile'
export const GLOBAL_REDUCER = 'global'
export const STOREFRONT_CART_REDUCER = 'storefrontCart'
